import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ConstantsService, SessionService, LookupsService, LoggerService, RequestTypesEnum,
  StepsIdEnum, StepsRouteEnum, EnvironmentService } from '@app/base/core';
import { MultistepsService } from '@app/modules/builder/base/services';
import { SubscriptionLike } from 'rxjs';

@Component({
  selector: 'app-newrequest',
  templateUrl: './newrequest.component.html',
  styleUrls: ['./newrequest.component.css'],
  providers: [MultistepsService]
})
export class NewRequestComponent implements OnInit, OnDestroy {
  stepsIdEnum: typeof StepsIdEnum = StepsIdEnum;
  requestTypeEnum: typeof RequestTypesEnum = RequestTypesEnum;
  locationSubscription: SubscriptionLike;
   BId: string;
  constructor(
    private router: Router,
    public lookupSvc: LookupsService,
    private route: ActivatedRoute,
    private location: Location,
    private logger: LoggerService,
    public environmentSvc: EnvironmentService,
    public constantsSvc: ConstantsService,
    public sessionSvc: SessionService,
    public wizardSvc: MultistepsService
  ) {
    this.subscribeRouteEvents();
  }

  ngOnInit() {
    this.sessionSvc.builderData.subscribe(success => {
      if (success) {

        const builderid = success.BuilderId[0];
        this.wizardSvc.deleteFolder(builderid).subscribe(res => {
        });
      }
      });

  }

  ngOnDestroy() {
    this.locationSubscription.unsubscribe();
  }

  private subscribeRouteEvents() {
    // Detect and resolve parameterized Request Type
    this.route.params.subscribe(params => {
      this.navigateToDefaultStep(); // No Type passed in route, route to default request type.
    });

    // Detect and act on route changes through platform navigation buttons, e.g. briowser back and forward
    this.locationSubscription = this.location.subscribe(event => {
      const resolvedStep = event.url
        .substr(event.url.lastIndexOf('/') + 1)
        .toUpperCase();
      // Ensure that step is a known step
      if (
        Object.keys(StepsRouteEnum)
          .map(e => StepsRouteEnum[e].toUpperCase())
          .indexOf(resolvedStep) >= 0
      ) {
        this.wizardSvc.goToStep(StepsIdEnum[resolvedStep]);
      } else { this.navigateToDefaultStep(); } // Couldn't recognize the step, route to default
    });
  }

  private navigateToDefaultStep() {
    this.wizardSvc.goToStep(this.stepsIdEnum.LOCATION);
  }

  setHeaderImage() {
    if (this.wizardSvc.getActiveStep.id === this.stepsIdEnum.LOCATION) {
      return 'location-banner';
    } else {
      if (!this.wizardSvc.selectedRequestType) {
        return 'residential-banner';
      } else {
        if (this.wizardSvc.getActiveStep.id !== this.stepsIdEnum.ACKNOWLEDGE) {
          switch (this.wizardSvc.getStepById(this.stepsIdEnum.TYPE).form.value.propertyType.id.toUpperCase()) {
            case RequestTypesEnum.Residential:
            case RequestTypesEnum.MultiFamily:
            case RequestTypesEnum.Subdivision:
              return 'residential-banner';
            case RequestTypesEnum.Commercial:
            case RequestTypesEnum.Industrial:
              return 'commercial-banner';
            case RequestTypesEnum.MixedUse:
              return 'mixed-use-banner';
          }
        }
      }
    }
  }
}
